export default {"src":"/_next/static/media/math.9216fbcd.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};